<template>
  <dialog
    v-if="true"
    :animated="false"
    animationType="none"
  >
    <div
      :style="styles.container"
      @click.stop
    >
      <div :style="styles.toast">
        <animation
          v-if="!supportNativeLoading"
          :playing="true"
          :actions="loopActions"
          :style="{height:calcNum(30),width:calcNum(30), position: 'absolute'}"
        >
          <img
            :src="loadingImg"
            :style="{height:calcNum(30),width:calcNum(30),backgroundColor: 'transparent'}"
          >
        </animation>
        <NBRefreshSimpleLoadingView
          v-if="supportNativeLoading && isNative"
          ref="viewLoading"
          :anim-style="2.0"
          :style="{height:calcNum(30),width:calcNum(30), position: 'absolute'}"
        />
      </div>
    </div>
  </dialog>
</template>

<script>
import Vue from 'vue';
import StyleSheet, { getFullHeight } from '@/components/basic/StyleSheet';
import { isNative } from '@/utils/env';
import loadingImg from './img/com-status-loading.png';

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    flexDirection: 'column',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1000,
    flex: 1,
  },
  toast: {
    position: 'absolute',
    width: 60,
    height: 60,
    top: getFullHeight() / 2 - 20,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.7)',
    borderRadius: 6,
  },
});

export default {
  name: 'LoadingToast',
  props: {},
  data() {
    return {
      styles,
      isNative,
      loopActions: {
        transform: {
          rotate: {
            startValue: 0,
            toValue: 360,
            duration: 1030,
            repeatCount: -1,
            valueType: 'deg',
            origin: 'center',
          },
        },
      },
      loadingImg,
      supportNativeLoading: true,
    };
  },
  created() {
    this.tools.compareVersion('1.5.0')
      .then((res) => {
        if (res.code >= 0) {
          this.supportNativeLoading = true;
        } else {
          this.supportNativeLoading = false;
        }
      });
  },
  mounted() {
    this.play();
  },
  beforeDestroy() {
    this.stop();
  },
  methods: {
    play() {
      Vue.Native.callUIFunction(this.$refs.viewLoading, 'startAnimation', null);
    },
    stop() {
      Vue.Native.callUIFunction(this.$refs.viewLoading, 'endAnimation', null);
    },
  },
};
</script>
